/**
 * @description Convert the value of search location to object based on window's location
 * @return An object that contains the value of search location
 * @returnType Record<string, string>
 */
export const windowSearchLocationToObject = () => {
  const pairs = window.location.search.substring(1).split("&");
  const obj: Record<string, string> = {};
  for (const pair of pairs) {
    if (pair !== "") {
      const splittedPair = pair.split("=");
      obj[decodeURIComponent(splittedPair[0])] = decodeURIComponent(
        splittedPair[1]
      );
    }
  }
  return obj;
};
